import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "corner-smooth-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", d: "M2.5 14.5c0-3.728 0-5.591.609-7.061a8 8 0 0 1 4.33-4.33C8.909 2.5 10.772 2.5 14.5 2.5h0" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
